export default __webpack_public_path__ + "static/media/match-service.1d1eaf23.svg";